module.exports = __webpack_public_path__ + "static/media/university_east_london_logo.b4e23496.png";